import React from 'react'
import { PosterCheckModal } from '../../../common/column.toolTips'
import { shipmentPopoverContent } from './column.toolTips'
import TooltipComponent from '../../../../../app/components/headerTooltip'
import { SortableTableHeader, FilterableTableHeader } from '../../../../../app/components/statelessDataTable/components/tableColumn'
import PosterCheck from '../tableCells/posterCheck'
import Address from '../tableCells/address'
import OrderInfo from '../tableCells/orderInfo'
import ShipmentInfo from '../tableCells/shipmentInfo'

const complianceShipmentsTableColumns = ({ sortOptions, filterOptions, eventHandlers, hasPosterCheck, openOrderModal }) => {
  const columns = [
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'addressee',
          text: 'Location',
          sortOptions,
          eventHandlers
        }}
        />
      ),

      Cell: ({ cell }) => <div className="text">{cell.row.original.shipment.address.addressee}</div>,
      accessor: 'addressee',
      width: 540,
      minWidth: 0, // default
      maxWidth: 0 // default
    },
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'address',
          text: 'Address',
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: 'address',
      width: 540,
      Cell: ({ cell }) => <Address {...cell.row.original} />
    },
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'orderNumber',
          text: 'Order Info',
          sortOptions,
          eventHandlers
        }}
        />
      ),
      width: 540,
      accessor: 'order',
      Cell: ({ cell }) => <OrderInfo {...cell.row.original} openOrderModal={openOrderModal} orderData={cell.row.original} />
    },
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'shipDate',
          text: 'Shipment Info',
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: 'shipmentInfo',
      width: 587,
      Cell: ({ cell }) => (
        <ShipmentInfo
          shipment={cell.row.values.shipment}
          order={{ ...cell.row.values.order, origin: cell.row.original.origin }}
        />
      ),
      toolTip: <TooltipComponent toolTip={shipmentPopoverContent} />
    },
    {
      Header: () => (
        <SortableTableHeader {...{
          field: 'status',
          text: 'Order Return Status',
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: 'shipment',
      width: 560,
      Cell: ({ cell }) => <div className="text">{cell.row.original.shipment.status}</div>,
      canSort: false
    },
    {
      Header: () => (
        <FilterableTableHeader {...{
          field: 'filter~posterCheck_status',
          text: (
            filterOptions.hasOwnProperty('filter~posterCheck_status')
            && filterOptions['filter~posterCheck_status'].display
              ? filterOptions['filter~posterCheck_status'].display
              : 'Poster Check'
          ),
          selection: [
            ['Clear Filter', ''],
            ['Verified', 'verified'],
            ['Unverified', 'unverified']
          ],
          filterOptions,
          eventHandlers
        }}
        />
      ),
      accessor: 'posterCheck',
      width: 515,
      Cell: ({ cell }) => <PosterCheck {...cell.row.original} />,
      toolTip: <PosterCheckModal />,
      canSort: false
    }
  ]

  return (!hasPosterCheck)
    ? columns.filter((column) => column.accessor !== 'posterCheck')
    : columns
}

export default complianceShipmentsTableColumns
